window.OKJS = window.OKJS || {};
(function (OKJS) {
    OKJS.Navigation = {

        settings: {
            lastScrollTop: window.pageYOffset || document.documentElement.scrollTop,
            menuCssTextFixedTop: "position: fixed; bottom: auto; top: 0px; transform: translateY(0px);",
            menuCssTextFixedBottom: "position: fixed; bottom: 0px; top: auto; transform: translateY(0px);",
            menuCssTextRelative: "position: relative; width: auto; bottom: auto; top: auto;"
        },

        init: function () {

            var settings = this.settings;

            this.setupMobileMenuToggle();
            this.setupLeftMenuExpand();
            this.setupminOkMenuExpand();
            this.setupGoToTopBtn();
            this.setupStickyLeftMenu(settings);
        },

        // set class on html element when mobile menu is open - to avoid silly body scroll
        setupMobileMenuToggle: function () {
            var mobileMenuToggle = document.getElementById("toggle-mobilemenu-input");

            if (mobileMenuToggle) {
                mobileMenuToggle.checked = false;
                mobileMenuToggle.addEventListener('change', function (e) {
                    if (mobileMenuToggle.checked) {
                        document.querySelector('html').classList.add('menu-open');
                    } else {
                        document.querySelector('html').classList.remove('menu-open');
                    }
                });
            }
        },

        // left menu expand button
        setupLeftMenuExpand: function () {
            var leftMenuExpand = document.querySelectorAll(".js-left-menu-expand");
            if (leftMenuExpand.length > 0) {
                for (var i = 0; i < leftMenuExpand.length; i++) {
                    leftMenuExpand[i].addEventListener("click", function (e) {
                        e.preventDefault();
                        var thisParent = this.parentElement,
                            childWrap = thisParent.parentElement.querySelector(".left-menu__child-wrap"),
                            childUl = childWrap.querySelector("ul"),
                            event = new Event('leftMenuToggle');

                        if (thisParent.classList.contains("left-menu__item--inpath")) {
                            thisParent.classList.remove("left-menu__item--inpath");
                            childWrap.style.height = childUl.clientHeight + 'px';
                            setTimeout(function () {
                                childWrap.style.height = '0px';
                            }, 50);
                        } else {

                            thisParent.classList.add("left-menu__item--inpath");
                            childWrap.style.height = childUl.clientHeight + 'px';

                            setTimeout(function () {
                                childWrap.style.height = "auto";
                            }, 500);
                        }
                        // call the toggle event setup in setupStickyLeftMenu()
                        window.dispatchEvent(event);
                    });
                };
            }
        },

        // special left menu expand button for profile item
        setupminOkMenuExpand: function () {
            var minOkMenuExpand = document.querySelectorAll(".js-minok-menu-expand");
            if (minOkMenuExpand.length > 0) {
                for (var i = 0; i < minOkMenuExpand.length; i++) {
                    minOkMenuExpand[i].addEventListener("click", function (e) {
                        e.preventDefault();
                        var thisParent = this.parentElement,
                            userMenu = document.querySelector(".mobile-user-menu"),
                            event = new Event('leftMenuToggle');

                        if (thisParent.classList.contains("left-menu__item--inpath")) {
                            thisParent.classList.remove("left-menu__item--inpath");
                            userMenu.classList.remove("mobile-user-menu--active");
                        } else {
                            thisParent.classList.add("left-menu__item--inpath");
                            userMenu.classList.add("mobile-user-menu--active");
                        }

                        window.dispatchEvent(event);
                    });
                };
            }
        },
        setupGoToTopBtn: function () {
            var goToTopBtn = document.querySelector(".js-page-top-btn");
            if (goToTopBtn) {
                if (window.innerWidth < 481) {
                    var throttledGoToTopUpdate = OKJS.Global.throttle(function () { OKJS.Navigation.goToTopUpdate(goToTopBtn) }, 200, { trailing: false });

                    window.addEventListener('scroll', function () {
                        requestAnimationFrame(throttledGoToTopUpdate);
                    }, Modernizr.passiveeventlisteners ? { passive: true } : false);
                }

                // smooth scrolling to the top
                goToTopBtn.addEventListener("click", function (e) {
                    e.preventDefault();
                    var anchorTarget = document.querySelector(e.currentTarget.hash);

                    animateScrollTo(anchorTarget, { maxDuration: 500 });
                });
            }
        },

        goToTopUpdate: function (goToTopBtn) {
            var scrollPositionTop = window.pageYOffset || document.documentElement.scrollTop,
                viewportHeight = window.innerHeight;

            if (!goToTopBtn.classList.contains('readytogo')) {
                if (scrollPositionTop > (viewportHeight * 1.5)) {
                    goToTopBtn.classList.add('readytogo');
                }
            } else if (scrollPositionTop < viewportHeight) {
                goToTopBtn.classList.remove('readytogo');
            }
        },

        setupStickyLeftMenu: function (settings) {
            var leftMenu = document.querySelector('.page-main__nav .left-menu');

            if (window.innerWidth > 1023 && leftMenu !== null) {

                var throttledStickyLeftMenuUpdate = OKJS.Global.throttle(function () { OKJS.Navigation.stickyLeftMenuUpdate(settings); }, 60, { trailing: true }),
                    throttledStickyLeftMenuUpdatePlacement = OKJS.Global.throttle(function () { OKJS.Navigation.stickyLeftMenuUpdatePlacement(); }, 500, { trailing: true });

                window.addEventListener('resize', function () {
                    requestAnimationFrame(throttledStickyLeftMenuUpdatePlacement);
                }, Modernizr.passiveeventlisteners ? { passive: true } : false);

                window.addEventListener('scroll', function () {
                    requestAnimationFrame(throttledStickyLeftMenuUpdate);
                }, Modernizr.passiveeventlisteners ? { passive: true } : false);

                window.addEventListener('leftMenuToggle', function () {

                    setTimeout(function () {
                        var leftMenu = document.querySelector('.page-main__nav .left-menu'),
                            content = document.querySelector('.page-main__content'),
                            translateYValue = (content.clientHeight - leftMenu.clientHeight) < 0 ? 0 : (content.clientHeight - leftMenu.clientHeight);

                        if ((leftMenu.getBoundingClientRect().bottom + window.pageYOffset) > (content.getBoundingClientRect().bottom + window.pageYOffset)) {
                            leftMenu.style.cssText = "position: relative; width: auto; bottom: auto; top: auto; transform: translateY(" + translateYValue + "px);";
                            leftMenu.dataset.state = "at-bottom";
                        }
                    }, 400);

                }, Modernizr.passiveeventlisteners ? { passive: true } : false);

                OKJS.Navigation.stickyLeftMenuUpdate(settings);
            }
        },
        childrenTotalHeight: function (parentElement) {
            var totalHeight = 0;

            for (var i = 0; i < parentElement.children.length; i++) {
                totalHeight = totalHeight + parentElement.children[i].clientHeight;
            }
            return totalHeight;
        },
        stickyLeftMenuUpdatePlacement: function () {
            var leftMenu = document.querySelector('.page-main__nav .left-menu'),
                leftMenuParentWidth = leftMenu.parentElement.clientWidth;

            leftMenu.style.width = leftMenuParentWidth + 'px';

        },
        stickyLeftMenuUpdate: function (settings) {

            var leftMenu = document.querySelector('.page-main__nav .left-menu'),
                content = document.querySelector('.page-main__content'),
                menuTooBigForContent = leftMenu.clientHeight > OKJS.Navigation.childrenTotalHeight(content);

            //is menu too large for the height of the viewport?
            if (!menuTooBigForContent) {
                var st = window.pageYOffset || document.documentElement.scrollTop,
                    sb = st + document.documentElement.clientHeight,
                    menuPositionValue = window.getComputedStyle(leftMenu).position,
                    menuTooBigForViewport = leftMenu.clientHeight > document.documentElement.clientHeight,
                    translateYValue;

                if (menuTooBigForViewport) {

                    if (st > settings.lastScrollTop) {
                        // scrolling down
                        //// if we are going down but the viewport has reached the top of the menu - maybee we have already passed the top earlier
                        if (leftMenu && leftMenu.dataset && leftMenu.dataset.state === "in-limbo-top") {
                            // then we either act as "normal going down" (see below) or we make it possible to scroll within the menu itself
                            if (sb > leftMenu.getBoundingClientRect().bottom + window.pageYOffset && menuPositionValue !== "fixed") {
                                leftMenu.style.cssText = settings.menuCssTextFixedBottom + " width:" + leftMenu.clientWidth + "px;";
                                leftMenu.dataset.state = "in-limbo-bottom";
                            } else {
                                leftMenu.style.cssText = settings.menuCssTextRelative + " transform: translateY(" + (leftMenu.getBoundingClientRect().top - content.getBoundingClientRect().top) + "px);";
                            }

                        } else {

                            // did viewport go past the bottom of the menu? a.k.a normal going down
                            if (sb > leftMenu.getBoundingClientRect().bottom + window.pageYOffset && leftMenu && leftMenu.dataset && leftMenu.dataset.state !== "at-bottom" && menuPositionValue !== "fixed") {
                                leftMenu.style.cssText = settings.menuCssTextFixedBottom + " width:" + leftMenu.clientWidth + "px;";
                                leftMenu.dataset.state = "in-limbo-bottom";
                            }
                            // did we reach the very top of the content area?
                            if (sb > content.getBoundingClientRect().bottom + window.pageYOffset && menuPositionValue !== "relative") {
                                translateYValue = (content.clientHeight - leftMenu.clientHeight) < 0 ? 0 : (content.clientHeight - leftMenu.clientHeight);
                                leftMenu.style.cssText = settings.menuCssTextRelative + " transform: translateY(" + translateYValue + "px);";
                                leftMenu.dataset.state = "at-bottom";
                            }
                        }
                    } else {
                        // scrolling up
                        //// if we are going up but the viewport has reached the bottom of the menu
                        if (leftMenu && leftMenu.dataset && leftMenu.dataset.state === "in-limbo-bottom") {

                            // then we either act as "normal going up" (see below) or we make it possible to scroll within the menu itself
                            if (st < leftMenu.getBoundingClientRect().top + window.pageYOffset && menuPositionValue !== "fixed") {
                                leftMenu.style.cssText = settings.menuCssTextFixedTop + " width:" + leftMenu.clientWidth + "px;";
                                leftMenu.dataset.state = "in-limbo-top";
                            } else {
                                leftMenu.style.cssText = settings.menuCssTextRelative + " transform: translateY(" + (leftMenu.getBoundingClientRect().top - content.getBoundingClientRect().top) + "px);";
                            }
                        } else {
                            // did viewport go past the top of the menu? a.k.a normal going up
                            if (st < leftMenu.getBoundingClientRect().top + window.pageYOffset && leftMenu && leftMenu.dataset && leftMenu.dataset.state !== "at-top" && menuPositionValue !== "fixed") {
                                leftMenu.style.cssText = settings.menuCssTextFixedTop + " width:" + leftMenu.clientWidth + "px;";
                                leftMenu.dataset.state = "in-limbo-top";
                            }
                            // did we reach the very bottom of the content area?
                            if (st < content.getBoundingClientRect().top + window.pageYOffset && menuPositionValue !== "relative") {
                                leftMenu.style.cssText = settings.menuCssTextRelative + " transform: translateY(0px);";
                                leftMenu.dataset.state = "at-top";
                            }
                        }
                    }
                } else {

                    if (st > settings.lastScrollTop) {
                        // scrolling down
                        if (st > leftMenu.getBoundingClientRect().top + window.pageYOffset && menuPositionValue !== "fixed" && leftMenu && leftMenu.dataset && leftMenu.dataset.state !== "at-bottom") {
                            leftMenu.style.cssText = settings.menuCssTextFixedTop + " width:" + leftMenu.clientWidth + "px;";
                            leftMenu.dataset.state = "in-limbo-top";
                        }

                        // did we reach the very bottom of the content area?
                        if (leftMenu.getBoundingClientRect().bottom + window.pageYOffset > content.getBoundingClientRect().bottom + window.pageYOffset) {
                            translateYValue = (content.clientHeight - leftMenu.clientHeight) < 0 ? 0 : (content.clientHeight - leftMenu.clientHeight);
                            leftMenu.style.cssText = settings.menuCssTextRelative + " transform: translateY(" + translateYValue + "px);";
                            leftMenu.dataset.state = "at-bottom";
                        }

                    } else {
                        // scrolling up
                        if (st < leftMenu.getBoundingClientRect().top + window.pageYOffset && leftMenu && leftMenu.dataset && leftMenu.dataset.state === "at-bottom" && menuPositionValue !== "fixed") {
                            leftMenu.style.cssText = settings.menuCssTextFixedTop + " width:" + leftMenu.clientWidth + "px;";
                            leftMenu.dataset.state = "in-limbo-bottom";
                        }
                        // did we reach the very top of the content area?
                        if (st < content.getBoundingClientRect().top + window.pageYOffset && menuPositionValue !== "relative") {
                            leftMenu.style.cssText = settings.menuCssTextRelative + " transform: translateY(0px);";
                            leftMenu.dataset.state = "at-top";
                        }
                    }
                }
            } else {
                leftMenu.style.cssText = "";
                leftMenu.dataset.state = "";
            }

            settings.lastScrollTop = st;
        }
    };

}(window.OKJS));
